import { KK } from "../../define/define";
import type { MacroDetails } from "../../action/action";
import { OutputMode, type KIO, type Output } from "../../define/define";
import { deviceManager } from "../../device/device_manager";
import { dataProfileManage } from "../../snapshot/profile";
import { deviceMap } from "@hid/define/define_list";
import { speciaBehiver, specialCheckCurrent } from "@/define/limit";
import { markKmeKeys } from "./handle_set_magnet_senior_key";
import { MagnetSeniorType } from "@libs/types/enum";

export const handleSetMacro = async (data: MacroDetails) => {
    const config = dataProfileManage().dataProfile
    const kk = Number(data.Key)

    if(data.Records.length == 0) {
        throw new Error("Macro is empty")
    }

    if(specialCheckCurrent(speciaBehiver.DeviceOfRoyuan)){
        data.Records.forEach(r => {
            if (r.Press == true) {
                const isHasRelease = data.Records.some((rr) => {
                    return rr.Key == r.Key && rr.Press == false
                })
                if (!isHasRelease) {
                    throw new Error("宏有未释放的按键")
                }
            }
        })
    }

    markKmeKeys(kk as KK, MagnetSeniorType.SeniorKeyTypeNone, config, data.IsFn)

    const macroIndex = getMacroIndex(kk as KK, data.IsFn)

    config.Keys.forEach((k, index) => {
        if (k.Input.KK == kk && data.IsFn == k.Input.WithFN) {
            config.Keys.splice(index, 1)
        }
    })

    config.Macros.set(macroIndex, data.Records);

    const mapKey: KIO = {
        Input: {
            KK: kk as KK,
            WithFN: data.IsFn,
            WithModifier: [],
        },
        Output: {
            Mode: OutputMode.Macro,
            DataIndex: macroIndex,
            Extension: [data.CycleType, data.CycleTimes]
        } as Output
    }

    config.Keys.push(mapKey)
    dataProfileManage().save()
    await deviceManager.deviceDriver.syncMacros()
}

function getMacroIndex(key: KK, isFn:boolean): number {
    const config = dataProfileManage().dataProfile

    const fd = config.Keys.find(k => k.Output.Mode == OutputMode.Macro && k.Input.KK == key && k.Input.WithFN == isFn)
    if (fd) return fd.Output.DataIndex

    for (let index = 0; index < deviceMap[deviceManager.deviceID].support.Limit.MacroIndexLen; index++) {
        if (!config.Macros.has(index)) {
            return index;
        }
    }

    throw new Error("No macro index available");
}